/* unplugin-vue-components disabled */import { render } from "./DistributorInfoClassList.vue?vue&type=template&id=96c87f52&scoped=true"
import script from "./DistributorInfoClassList.vue?vue&type=script&lang=js"
export * from "./DistributorInfoClassList.vue?vue&type=script&lang=js"

import "./DistributorInfoClassList.vue?vue&type=style&index=0&id=96c87f52&scoped=true&lang=css"

import exportComponent from "D:\\星网代码\\2018-05-18 路特利\\2022-02-23需求\\DM.LtlApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96c87f52"]])

export default __exports__